module.exports = __webpack_public_path__ + "img/tea1.ff3df10f.png";